/* Filtro por serie de la parrilla de diseños. Sin JavaScript se ven todos, que
   es el comportamiento correcto: el filtro es una comodidad, no un requisito. */
(function () {
  'use strict';
  var raiz = document.querySelector('[data-af-disenos]');
  if (!raiz) return;
  var tabs = raiz.querySelectorAll('.af-tab');
  var tarjetas = raiz.querySelectorAll('.af-card');
  var vacio = document.getElementById('af-disenos-vacio');
  var estado = document.getElementById('af-disenos-estado');
  if (!tabs.length) return;

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var serie = tab.dataset.serie;
      var n = 0;
      tabs.forEach(function (t) { t.setAttribute('aria-pressed', t === tab ? 'true' : 'false'); });
      tarjetas.forEach(function (c) {
        var ok = serie === 'todas' || c.dataset.serie === serie;
        c.hidden = !ok;
        if (ok) n++;
      });
      if (vacio) vacio.hidden = n > 0;
      if (estado) estado.textContent = n + (n === 1 ? ' diseño' : ' diseños');
    });
  });
})();
